import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// si se agrega un formato, permitirlo también en utils/sanitizarHtml.js y en
// el backend (utils.SanitizarHTML)

const FORMATOS = ["header", "bold", "italic", "underline", "list", "link"];

const barra = (conTitulos) => [
  ...(conTitulos ? [[{ header: [1, 2, false] }]] : []),
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["clean"],
];

const EditorTexto = ({ value, onChange, conTitulos = true, placeholder }) => (
  <ReactQuill
    style={{ height: "auto" }}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    modules={{ toolbar: barra(conTitulos) }}
    formats={conTitulos ? FORMATOS : FORMATOS.filter((f) => f !== "header")}
  />
);

export default EditorTexto;
